import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ExcludeHeaderRequestInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('cloudflare')) {
      const clonedRequest = request.clone({ headers: request.headers.delete('Authorization') });
      return next.handle(clonedRequest);
    }
    return next.handle(request);
  }
}
